import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalSearchService {
  private readonly _http = inject(HttpClient);

  private readonly _apiUrl = environment.apiUrl;

  find(query: string, teamId: number, coursePermission: number) {
    return this._http.get<any>(`${this._apiUrl}/globalSearch/${query}/${teamId}/${coursePermission}`).pipe(map((res) => res.result));
  }
}
